import React, { useState } from 'react';
import type { MessageButton, CommandVariable } from '../../../../types/chat-message';
import { DateRangePickerModal } from '../Conversation/DateRangePickerModal';
import { getButtonStyle } from '@utils/buttonUtils';

const checkIsHidden = (commandVariables?: CommandVariable[]): boolean => {
  if (!commandVariables) return false;
  return commandVariables.find(v => v.name === 'hidden_message')?.value === 'true';
};

interface ReportActionButtonsProps {
  buttons?: MessageButton[];
  isDisabled: boolean;
  onButtonClick?: (name: string, id: any, isHidden?: boolean) => void;
  reportType?: string;
}

export const ReportActionButtons: React.FC<ReportActionButtonsProps> = ({
  buttons,
  isDisabled,
  onButtonClick,
  reportType,
}) => {
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [selectedButtonId, setSelectedButtonId] = useState<number | null>(null);

  if (!buttons || buttons.length === 0) return null;

  const handleButtonClick = (btn: MessageButton) => {
    if (btn.name === 'Chọn thời gian') {
      setSelectedButtonId(btn.id);
      setShowDatePicker(true);
    } else {
      onButtonClick?.(btn.name, btn.id, checkIsHidden(btn.commandVariables));
    }
  };

  const handleDateRangeConfirm = (dateRange: string) => {
    if (selectedButtonId !== null) {
      onButtonClick?.(dateRange, null, false);
      setShowDatePicker(false);
      setSelectedButtonId(null);
    }
  };

  return (
    <>
     <hr style={{ borderColor: '#E5E5E7', borderTopWidth: 1, margin: '8px 0' }} />
    
      <div className="rr-buttons">
        {buttons.map((btn, i) => (
          <button
            key={btn.id ?? i}
            className={`rr-btn${isDisabled ? ' disabled' : ''}`}
            disabled={isDisabled}
            style={getButtonStyle(btn, isDisabled)}
            onClick={() => !isDisabled && handleButtonClick(btn)}
            type="button"
          >
            {btn.name}
          </button>
        ))}
      </div>
      <DateRangePickerModal
        open={showDatePicker}
        onClose={() => setShowDatePicker(false)}
        onConfirm={handleDateRangeConfirm}
        reportType={reportType}
      />
    </>
  );
};
